import { useTranslation } from 'react-i18next';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Menu } from '../types';

interface VersionHistoryTabProps {
  menu: Menu;
}

const VersionHistoryTab = ({ menu }: VersionHistoryTabProps) => {
  const { t } = useTranslation('menus');

  if (menu.versionHistory.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noVersionHistory', 'No version history is available for this menu.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('version', 'Version')}</TableCell>
            <TableCell>{t('date', 'Date')}</TableCell>
            <TableCell>{t('changeSummary', 'Change Summary')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...menu.versionHistory].reverse().map((entry) => (
            <TableRow key={entry.version}>
              <TableCell>v{entry.version}</TableCell>
              <TableCell>{entry.date}</TableCell>
              <TableCell>{entry.changeSummary}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default VersionHistoryTab;
